module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowledgments",
    attrs: {
      "id": "ack"
    }
  }, [_c('p', {
    staticClass: "chapterTitle1"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Help with this book has come from several kind people who have given time, photographs and assistance with the project. Many thanks therefore go to: Paul Baillie, John Larder (BoB Historical Society), Andy Saunders, Chris Shores, Andy Thomas, Barry Weekley, Mrs K Wright and her daughter Sarah, and the late Fred Woodgate.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9afc8aea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_TallyHo_acknowledgment.vue
// module id = 207
// module chunks = 0